module.exports = __webpack_public_path__ + "static/media/double-chocolate-mint.0db1801e.png";